import BasicAlert from "../../Components/Alerts/BasicAlert";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import useAdmin from "./useAdmin";
import axios from "axios";
import swal from 'sweetalert';

const AdminEditForm = ({ admin, setAdmin, status, errors }) => {
    const [roles, setRoles] = useState([]);
    const [firstName, setFirstName] = useState(admin?.first_name ?? "");
    const [lastName, setLastName] = useState(admin?.last_name ?? "");
    const { reset, handleSubmit, setErrors, adminFields } = useAdmin();
    const navigate = useNavigate();

    useEffect(() => {
        axios.get('/admins/create')
          .then(res => {
              if (res.data.status === 'success') {
                  setRoles(res.data.roles)
              }
          })
    }, []);

    const editAdmin = data => {
        axios.patch('admins/' + data.id, {
            first_name: data.first_name,
            last_name: data.last_name,
            email: data.email,
            password: data.password,
            phone: data.phone ? data.phone : null,
        })
            .then(function (res) {
                if (res.status == 200) {
                    swal('Admin has been updated successfully!', {
                        icon: "success",
                    });
                    navigate("/admins");
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    return (
        <div>
            {
                status && (
                    <BasicAlert
                        title="Success!"
                        body="User has been updated successfully!"
                        alertClass="alert alert-success"
                    />
                )
            }

            <form id="kt_modal_add_schedule_form" className="form row" onSubmit={handleSubmit(editAdmin)}>
                <div className="fv-row mb-7 d-flex gap-5">
                    <div className="w-50">
                        <label className="required fs-6 fw-bold form-label mb-2">First Name</label>
                        <input
                            type="text"
                            className="form-control form-control-solid"
                            name="event_name"
                            value={firstName}
                            onChange={e => setFirstName(e.target.value)}
                        />
                        {errors['first_name'] && (
                            <div className="fv-plugins-message-container invalid-feedback">
                                <div>{errors['first_name'][0]}</div>
                            </div>
                        )}
                    </div>
                    <div className="w-50">
                        <label className="required fs-6 fw-bold form-label mb-2">Last Name</label>
                        <input
                            type="text"
                            className="form-control form-control-solid"
                            name="event_name"
                            value={admin?.last_name ?? ""}
                            onChange={e => setFirstName(e.target.value)}
                        />
                        {errors['last_name'] && (
                            <div className="fv-plugins-message-container invalid-feedback">
                                <div>{errors['last_name'][0]}</div>
                            </div>
                        )}
                    </div>

                </div>
                <div className="fv-row mb-7 d-flex gap-5">
                    <div className="w-50">
                        <label className="fs-6 fw-bold form-label mb-2">
                            <span className="required">Personal Number</span>
                        </label>
                        <input
                            type="text"
                            className="form-control form-control-solid"
                            name="personal_number"
                            required={true}
                            value={admin?.personal_number ?? ""}
                            onChange={event => setAdmin({ ...admin, personal_number: event.target.value })}
                        />
                        {errors['personal_number'] && (
                            <div className="fv-plugins-message-container invalid-feedback">
                                <div>{errors['personal_number'][0]}</div>
                            </div>
                        )}
                    </div>
                    <div className="w-50">
                        <label className="fs-6 fw-bold form-label mb-2">
                            <span className="required">Role</span>
                        </label>
                        <select className="form-select" aria-label="Select example"
                            onChange={event =>
                                setAdmin({
                                    ...admin, roles: roles.filter(role => {
                                        return role.id === parseInt(event.target.value)
                                    })
                                })
                            }
                        >
                            {
                                roles.map(role => (
                                    <option
                                        key={role.id}
                                        value={role.id}
                                        selected={admin.roles && admin.roles[0].id === role.id}
                                    >
                                        {role.name}
                                    </option>
                                ))
                            }
                        </select>
                    </div>
                </div>
                <SubmitButton title="Update" classes="float-right inline-block w-auto mx-3" />
            </form>
        </div>
    )
}

export default AdminEditForm;